import { Direction } from "src/grid/Direction";
import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

const DIRECTIONS_IN_CLOCKWISE_ORDER: Direction[] = [
  "up",
  "right",
  "down",
  "left",
];

function getNextCloseWiseDirection(direction: Direction) {
  const currentIndex = DIRECTIONS_IN_CLOCKWISE_ORDER.indexOf(direction);
  // mod by length to wrap around if we're on the last index
  const nextIndex = (currentIndex + 1) % DIRECTIONS_IN_CLOCKWISE_ORDER.length;
  return DIRECTIONS_IN_CLOCKWISE_ORDER[nextIndex];
}

export class FaceThenRotateInstruction<
  T extends Direction
> extends Instruction<T> {
  readonly type: T;

  constructor(private direction: Direction) {
    super();
    this.type = ("face-" + this.direction + "-rotate") as T;
  }

  act(context: ProgramModel) {
    context.cursorDirection = this.direction;
    context.instructions.set(
      context.cursorGridLocation.toHash(),
      new FaceThenRotateInstruction(getNextCloseWiseDirection(this.direction))
    );
  }
}
